import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '../Tooltip';
import { NoResponse } from 'static';
import {
  StyledStatusIndicator,
  StyledTooltipContent,
  StyledActionPath,
} from './styled';

interface StatusIndicatorProps {
  type: 'not-activated' | 'task-inactive' | 'awaiting-reply';
  zoom?: number;
}

const StatusIndicator: FC<StatusIndicatorProps> = ({ type, zoom = 1 }) => {
  const { t } = useTranslation();

  const getStatusColor = () => {
    switch (type) {
      case 'not-activated':
        return '#09fb25'; // White
      case 'task-inactive':
        return '#0400ff'; // White
      case 'awaiting-reply':
        return '#ff0000'; // Brown
      default:
        return '#1f0e0e';
    }
  };

  const getTooltipContent = () => {
    const content = {
      'not-activated': {
        message: t('status.notActivated'),
        description: t('status.notActivatedDesc'),
        action: t('status.notActivatedAction'),
      },
      'task-inactive': {
        message: t('status.taskInactive'),
        description: t('status.taskInactiveDesc'),
        action: t('status.taskInactiveAction'),
      },
      'awaiting-reply': {
        message: t('status.awaitingReply'),
        description: t('status.awaitingReplyDesc'),
        action: t('status.awaitingReplyAction'),
      },
    }[type];

    return (
      <StyledTooltipContent>
        {type === 'awaiting-reply' ? (
          <div style={{ display: 'table', width: '100%' }}>
            <div style={{ display: 'table-row' }}>
              <div
                style={{
                  display: 'table-cell',
                  width: '14px',
                  verticalAlign: 'middle',
                }}
              >
                <div
                  style={{
                    marginLeft: `${-3 * zoom}px`,
                    transform: `scale(${zoom * 0.65})`,
                    transformOrigin: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%',
                  }}
                >
                  <NoResponse />
                </div>
              </div>
              <div
                style={{
                  display: 'table-cell',
                  verticalAlign: 'middle',
                }}
              >
                {content.message}
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '3px',
            }}
          >
            <span style={{ fontSize: `${14 * zoom}px` }}>◻️</span>
            <span>{content.message}</span>
          </div>
        )}
        <div>{content.description}</div>
        {content.action && (
          <StyledActionPath>{content.action}</StyledActionPath>
        )}
      </StyledTooltipContent>
    );
  };

  return (
    <Tooltip
      isVisible
      text={getTooltipContent()}
      zoom={zoom}
      position="top-center"
      tooltipStyle={{
        maxWidth: '300px',
        // lineHeight: '1.4',
        textAlign: 'left',
      }}
    >
      <StyledStatusIndicator color={getStatusColor()} />
    </Tooltip>
  );
};

export default StatusIndicator;
